<template>   
  <form class="relative hide-submit2" onsubmit="return false;">
    <div class="relative z-7 email-input-wrapper">
      <input class="dib m-2 input-css z-1" type="email" id="email" name="email" required="required" placeholder=" " v-model="submission.userEmail" />
      <label for="email" class="f4 f4-ns tc is-orange z--1">enter email</label>
      <div class="absolute is-tablet-cond-bold is-red requirements">
        Must be a valid email address.
      </div>
      <div v-show="successMessageIsVisible" class="absolute mt1 success-message is-tablet-cond-bold is-red">
        Thanks for signing up!
      </div>
    </div>
    <div class="relative z-7 email-input-wrapper">
      <input class="dib m-2 input-css z-1" type="tel" id="tel" name="tel" required="required" placeholder=" " v-model="number" />
      <label for="tel" class="f4 f4-ns tc is-orange z--1">enter mobile number</label>
      <div class="absolute is-tablet-cond-bold is-red requirements">
        Must be a valid phone number.
      </div>
      <div v-show="successMessageIsVisible" class="absolute mt1 success-message is-tablet-cond-bold is-red">
        Thanks for signing up!
      </div>
    </div>
    <div class="relative z-7 email-input-wrapper">
      <input class="dib input-css z-1" type="zip" id="zip" name="zip" required="required" placeholder=" " v-model="submission.userZip" />
      <label for="zip" class="f4 f4-ns tc is-orange z--1">enter zip code</label>
      <div class="absolute is-tablet-cond-bold is-red requirements">
        Must be a valid zip code.
      </div>
      <div v-show="successMessageIsVisible" class="absolute mt1 success-message is-tablet-cond-bold is-red">
        Thanks for signing up!
      </div>
    </div>
    <div class="relative z-2 submit-button-email2 button-transform">
      <div @click="submitForm()" class="flex w4 header-cta2 has-red-bg overflow-hidden pointer link">
        <span class="text submit-button-email2 is-lorano-bold">SUBMIT</span>
        </div>
    </div>
  </form>
</template>

<script>
  import AWS from 'aws-sdk/global';
  import Config from 'aws-sdk/clients/lambda';
  import axios from 'axios';
  export default {
    data () {
      return {
        number: '',
        submission: {
          userEmail: '',
          userPhone: '',
          userZip: '',
          format: '',
          regex: '^'
        },
        successMessageIsVisible: false
      }
    },

    //regex to auto format number
    watch: {
      number() {
        this.number = this.number.replace(/[^0-9]/g, '')
          .replace(/^(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3')
          // .substr(0, this.number.length);
      }
    },

    props: ['data'],
    methods: {
      checkValidEmail(userEmail) {
        /*
        * Email Newsletter Signup email validation
        */
        if (userEmail !== undefined && /(.+)@(.+){2,}\.(.+){2,}/.test(userEmail)) {
          return true;
        }
        console.log("false, check this out useremail", userEmail);
        return false;
      },
      checkValidPhone(userPhone) {
        /*
        * Email Newsletter Signup email validation
        */
        if (userPhone !== undefined && /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im.test(userPhone)) {
          return true;
        }
        console.log("false, check this out userphone", userPhone);
        return false;
      },
      checkValidZip(userZip) {
        /*
        * Email Newsletter Signup email validation
        */
        if (userZip !== undefined && /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(userZip)) {
          return true;
        }
        console.log("false, check this out userzip", userZip);
        return false;
      },

      submitEmail() {
        var userEmail = this.submission.userEmail.toLowerCase();
        var userPhone = this.number.toLowerCase();
        var userZip = this.submission.userZip.toLowerCase();

        if (this.checkValidEmail(userEmail) === true) {
          var userEmail = userEmail.toString().toLowerCase();
           var userPhone = userPhone.toString().toLowerCase();
           var userZip = userZip.toString().toLowerCase();
           this.subscribe(userEmail, userPhone, userZip);
          this.successMessageIsVisible = true;
          setTimeout(() => {
            this.successMessageIsVisible = false;
            //this.$refs.emailInput.value == '';
            this.submission.userEmail = '';
            this.submission.userPhone = '';
            this.submission.userZip = '';
            this.number = '';
            
            console.log("success, you submitted", userEmail, userPhone, userZip);
          }, 5000);
        }
        else {
          console.log('email is not valid: ', userEmail);
        }
      },


      submitForm() {
        //console.log('1.0 submitForm - ', this.submission.userEmail);
        this.submitEmail();
      },

  subscribe(userEmail, userPhone, userZip) {
        // fill in arn for lambda role and identity pool id
        var params = {
          AllowUnauthenticatedIdentities: true,
          RoleArn: "arn:aws:iam::329953418920:role/Cognito_OLNewsletterSignupUnauth_Role", // Cognito unauth role
          IdentityPoolId: "us-east-1:9217214c-cb34-4724-8fd2-f05dbc5db899" // the identity pool id found in Cognito
        };
        // set the Amazon Cognito region
        AWS.config.region = 'us-east-1';
        // initialize the Credentials object with our parameters
        AWS.config.credentials = new AWS.CognitoIdentityCredentials(params);
        // invoking the actual Lambda function
        var lambda = new AWS.Lambda();
        lambda.invoke(
          {
            FunctionName: 'olEmailNewsletterSubscribeV2', // your function name
            LogType: "Tail",
            InvocationType: "Event",
            Payload: JSON.stringify({
              "email": userEmail,
              "phone": userPhone,
              "zip": userZip
              //"phone": userPhone
            }) // how you send the email to the Lambda event
          }, 
          function(err, data) {
            if (err) {
              console.log(err, err.stack);
            } 
            else {
              console.log('Thanks! You signed up to the Outside Lands email list: ', userEmail, userPhone, userZip);
            }
          }
        );
      }
  //////////this is where old function starts /////////////

    },
    // mounted() {
    //   let x = 1;
    //   this.format = this.submission.number.replace(/x+/g, () => '$' + x++);

    //   this.submission.number.match(/x+/g.forEach((char, key) => {
    //     this.regex += '(\\d{' + char.length + '})?';
    //     console.log(this.regex)
    //   }));
    // },

  }
</script>